<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
            <a-input :disabled="params.isShow" placeholder="请输入联系人" v-decorator="[
          'contact',
          {initialValue:data.contact,rules: [{ required: true, message: '请输入联系人' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input :disabled="params.isShow" placeholder="请输入联系电话" v-decorator="[
          'telephone',
          {initialValue:data.telephone,rules: [{ required: true, message: '请输入联系电话' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址">
            <a-cascader :disabled="this.params.isShow" :options="addressOptions" expandTrigger="hover" @change="changeAddressdata" placeholder="请选择地址" v-decorator="[
          'defaultValue',
          {initialValue:defaultValue,rules: [{ required: true, message: '请选择地址' }]}]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="详细地址">
            <a-input :read-only="this.params.isShow" placeholder="请输入详细地址" v-decorator="[
          'address',
          {initialValue:data.address,rules: [{ required: true, message: '请输入详细地址' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="默认地址">
            <a-radio-group name="isDefault" v-decorator="[
          'isDefault',
          {initialValue:data.isDefault,rules: [{ required: false, message: '默认地址' }]}]">
              <a-radio :value="true">是</a-radio>
              <a-radio :value="false">否</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  address: "",
  contact: "",
  telephone: "",
  isDefault: false
};
export default {
  name: "hp-manager-page-dealerAddress-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  components: {},
  data() {
    return {
      loading: false,
      addressOptions: config.addressJson,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      defaultValue: [],
      dealerId: null
    };
  },

  async mounted() {
    if (this.params.id) {
      this.getDealerAddress();
    } else {
      this.data = exzends(defaultData);
    }
    this.dealerId = this.params.dealerId;
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    changeAddressdata(option) {
      console.log(option);
      this.data.provinceId = parseInt(option[0]);
      this.data.cityId = parseInt(option[1]);
      if (option[2]) {
        this.data.districtId = option[2];
      }
      console.log(this.form);
      this.form.setFieldsValue({
        provinceId: this.data.provinceId
      });
    },

    async getDealerAddress() {
      this.loading = true;
      let result = await api.GetDealerAddress({ id: this.params.id });
      if (result) {
        this.data = result;
        this.defaultValue = [
          this.data.provinceId + "",
          this.data.cityId + "",
          this.data.districtId + ""
        ];
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        telephone: value.telephone,
        contact: value.contact,
        provinceId: this.data.provinceId,
        cityId: this.data.cityId,
        districtId: this.data.districtId,
        address: value.address,
        isDefault: value.isDefault,
        dealerId: this.params.dealerId
      };
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });

      console.log(valid);
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.AddOrUpdateDealerAddress(requestData);
        if (this.params.id > 0) {
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Dealer/AddDealerAdderss.vue